const setValue = (obj, path, value) => {
  const keys = path.split('.');
  let o = obj;

  keys.map((key, i) => {
    if (i >= keys.length - 1) return false;
    o[key] = o[key] || {};
    o = o[key];
    return true;
  });

  o[keys[keys.length - 1]] = value;
};

export const getDeepValue = (obj, path) => {
  let o = obj;
  let p = path.replace(/\[(\w+)\]/g, '.$1');
  p = path.replace(/^\./, '');
  const keys = p.split('.');
  while (keys.length) {
    const n = keys.shift();
    if (n in o) {
      o = o[n];
    } else {
      return;
    }
  }
  return o;
};

export const setDeepValue = (obj, path, value) => {
  const newData = { ...obj };
  setValue(newData, path, value);
  return newData;
};

export const parseAgents = (data) => {
  const parsedAgents = Object.keys(data).map((key) => {
    const agentData = data[key].split(';');
    const agentObj = { id: key, phone: {}, comment: data[key] };

    agentData.forEach((item, index) => {
      if (index === 0) {
        const parts = item.split(',');
        agentObj.name = (parts[0] || '').trim();
        agentObj.company = (parts[1] || '').trim();
        agentObj.address = { line1: (parts[2] || '').trim() };
      }

      if (item.indexOf('EMail') > -1) {
        agentObj.email = item.replace('EMail', '').trim();
      }

      if (item.indexOf('Office Phone') > -1) {
        agentObj.phone.business = item.replace('Office Phone', '').trim();
      }

      if (item.indexOf('Direct Phone') > -1 && data[key].indexOf('Office Phone') === -1) {
        agentObj.phone.business = item.replace('Direct Phone', '').trim();
      }
    });
    return agentObj;
  });

  return parsedAgents;
};
